import React from "react";
import Lozenge from "@atlaskit/lozenge";
import Avatar from "@atlaskit/avatar";
import {
  statusBackColor,
  createKey,
  jobTypeBgColor,
  formatDateJobLog,
  secondsToDhms,
} from "../../../helpers/helpers";
import Tooltip from "@atlaskit/tooltip";
import Button from "@atlaskit/button";
import ArrowUpIcon from "@atlaskit/icon/glyph/arrow-up";
import ArrowDownIcon from "@atlaskit/icon/glyph/arrow-down";
import styles from "./WrapperBackup.module.css";
import Skeleton from "react-loading-skeleton";
export const TableWrapper = ({ children }) => (
  <div className={styles.tableWrapperStyles}>{children}</div>
);
export const NameWrapper = ({ children }) => (
  <span className={styles.nameWrapperStyles}>{children}</span>
);

export const AvatarWrapper = ({ children }) => (
  <div className={styles.avatarWrapperStyles}>{children}</div>
);
export const createHead = (withWidth, appType, sortFlags, handleSorting) => {
  return {
    cells: [
      {
        content: <div className={styles.field}>Job Id</div>,
        key: "jobId",
        isSortable: false,
        isFixedSize: true,
        width: withWidth ? 25 : undefined,
      },
      appType === "Backup"
        ? {
            content: (
              <Button
                style={
                  sortFlags.tagSortFlag === 0
                    ? { backgroundColor: "#fff" }
                    : { backgroundColor: "#f5f5f5" }
                }
                iconAfter={
                  sortFlags.tagSortFlag === 0 ? (
                    ""
                  ) : sortFlags.tagSortFlag === 1 ? (
                    <ArrowUpIcon size="small" />
                  ) : sortFlags.tagSortFlag === 2 ? (
                    <ArrowDownIcon size="small" />
                  ) : (
                    ""
                  )
                }
                onClick={() =>
                  handleSorting(
                    "tag",
                    sortFlags.tagSortFlag === 0
                      ? "asc"
                      : sortFlags.tagSortFlag === 1
                      ? "desc"
                      : sortFlags.tagSortFlag === 2
                      ? ""
                      : ""
                  )
                }
              >
                Tag
              </Button>
            ),
            key: "tag",
            isSortable: false,
            isFixedSize: true,
            width: withWidth ? 30 : undefined,
          }
        : "",
      {
        content: <div className={styles.field}>Type</div>,
        key: "jobType",
        isSortable: false,
        isFixedSize: true,
        width: withWidth ? 20 : undefined,
      },
      {
        content: (
          <Button
            style={
              sortFlags.startTimeSortFlag === 0
                ? { backgroundColor: "#fff" }
                : { backgroundColor: "#f5f5f5" }
            }
            iconAfter={
              sortFlags.startTimeSortFlag === 0 ? (
                ""
              ) : sortFlags.startTimeSortFlag === 1 ? (
                <ArrowUpIcon size="small" />
              ) : sortFlags.startTimeSortFlag === 2 ? (
                <ArrowDownIcon size="small" />
              ) : (
                ""
              )
            }
            onClick={() =>
              handleSorting(
                "start_time",
                sortFlags.startTimeSortFlag === 0
                  ? "asc"
                  : sortFlags.startTimeSortFlag === 1
                  ? "desc"
                  : sortFlags.startTimeSortFlag === 2
                  ? ""
                  : ""
              )
            }
          >
            Start time (UTC)
          </Button>
        ),
        key: "startTime",
        isSortable: false,
        isFixedSize: true,
        width: withWidth ? 30 : undefined,
      },
      {
        content: (
          <Button
            style={
              sortFlags.endTimeSortFlag === 0
                ? { backgroundColor: "#fff" }
                : { backgroundColor: "#f5f5f5" }
            }
            iconAfter={
              sortFlags.endTimeSortFlag === 0 ? (
                ""
              ) : sortFlags.endTimeSortFlag === 1 ? (
                <ArrowUpIcon size="small" />
              ) : sortFlags.endTimeSortFlag === 2 ? (
                <ArrowDownIcon size="small" />
              ) : (
                ""
              )
            }
            onClick={() =>
              handleSorting(
                "end_time",
                sortFlags.endTimeSortFlag === 0
                  ? "asc"
                  : sortFlags.endTimeSortFlag === 1
                  ? "desc"
                  : sortFlags.endTimeSortFlag === 2
                  ? ""
                  : ""
              )
            }
          >
            End Time (UTC)
          </Button>
        ),
        key: "endTime",
        isSortable: false,
        isFixedSize: true,
        width: withWidth ? 30 : undefined,
      },
      {
        content: <div className={styles.field}>Time taken </div>,
        // content: (
        //   <Button
        //     style={
        //       sortFlags.timeTakenSortFlag === 0
        //         ? { backgroundColor: "#fff" }
        //         : { backgroundColor: "#f5f5f5" }
        //     }
        //     iconAfter={
        //       sortFlags.timeTakenSortFlag === 0 ? (
        //         ""
        //       ) : sortFlags.timeTakenSortFlag === 1 ? (
        //         <ArrowUpIcon size="small" />
        //       ) : sortFlags.timeTakenSortFlag === 2 ? (
        //         <ArrowDownIcon size="small" />
        //       ) : (
        //         ""
        //       )
        //     }
        //     onClick={() =>
        //       handleSorting(
        //         "time_taken",
        //         sortFlags.timeTakenSortFlag === 0
        //           ? "asc"
        //           : sortFlags.timeTakenSortFlag === 1
        //           ? "desc"
        //           : sortFlags.timeTakenSortFlag === 2
        //           ? ""
        //           : ""
        //       )
        //     }
        //   >
        //     Time Taken
        //   </Button>
        // ),
        key: "timeTaken",
        isSortable: false,
        isFixedSize: true,
        width: withWidth ? 20 : undefined,
      },
      {
        content: (
          <Button
            style={
              sortFlags.statusSortFlag === 0
                ? { backgroundColor: "#fff" }
                : { backgroundColor: "#f5f5f5" }
            }
            iconAfter={
              sortFlags.statusSortFlag === 0 ? (
                ""
              ) : sortFlags.statusSortFlag === 1 ? (
                <ArrowUpIcon size="small" />
              ) : sortFlags.statusSortFlag === 2 ? (
                <ArrowDownIcon size="small" />
              ) : (
                ""
              )
            }
            onClick={() =>
              handleSorting(
                "status",
                sortFlags.statusSortFlag === 0
                  ? "asc"
                  : sortFlags.statusSortFlag === 1
                  ? "desc"
                  : sortFlags.statusSortFlag === 2
                  ? ""
                  : ""
              )
            }
          >
            Status
          </Button>
        ),
        key: "status",
        isSortable: false,
        isFixedSize: true,
        width: withWidth ? 20 : undefined,
      },
      // {
      //   content: "Started By",
      //   key: "startedBy",
      //   isSortable: false,
      //   isFixedSize: true,
      //   width: withWidth ? 30 : undefined,
      // },
      // {
      //   content: "Progress",
      //   key: "progress",
      //   isSortable: false,
      //   isFixedSize: true,
      //   width: withWidth ? 20 : undefined,
      // },
      // {
      //   content: "Tag",
      //   key: "tag",
      //   isSortable: false,
      //   isFixedSize: true,
      //   width: withWidth ? 20 : undefined,
      // },
      // {
      //   content: "Error Code Details",
      //   key: "errorCodeDetails",
      //   isSortable: false,
      //   isFixedSize: true,
      //   width: withWidth ? 60 : undefined,
      // },
      {
        content: <div className={styles.field}>Initiator</div>,
        key: "Initiator",
        isSortable: false,
        isFixedSize: true,
        width: withWidth ? 25 : undefined,
      },
    ],
  };
};

export const createCells = (
  backupJobs,
  appType,
  totalIssueCount,
  navigate,
  totalPages
) =>
  backupJobs.map((data, index) => ({
    key: `row-${index}-${data.id}`,
    cells: [
      {
        key: createKey(String(data.jobId)),
        content: (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <div>
            <Button
              spacing="default"
              appearance="link"
              onClick={() => {
                appType === "Backup"
                  ? navigate(
                      `/backup/jobs/details?id=${data.jobId}&tag=${
                        data.tag
                      }&type=${data.type}&startTime=${formatDateJobLog(
                        data.startTime
                      )}&endTime=${formatDateJobLog(
                        data.endTime
                      )}&timeTaken=${secondsToDhms(data.timeTakenSec)}&status=${
                        data.status
                      }&triggeredby=${
                        data.initiatorAccountId
                      }&appType=${appType}&totalJobs=${totalPages}&totalissue=${totalIssueCount}`
                    )
                  : navigate(
                      `/restore/jobs/details?id=${data.jobId}&tag=${
                        data.tag
                      }&type=${data.type}&startTime=${data.startTime}&endTime=${
                        data.endTime
                      }&timeTaken=${secondsToDhms(data.timeTakenSec)}&status=${
                        data.status
                      }&triggeredby=${
                        data.initiatorAccountId
                      }&appType=${appType}&totalJobs=${totalPages}`
                    );
              }}
            >
              {data.jobId}
            </Button>
          </div>
        ),
      },
      appType === "Backup"
        ? {
            key: createKey(data.tag),
            content: data.tag,
          }
        : "",
      {
        key: createKey(data.jobType),
        content:
          data.type === "Issues" ? (
            <Lozenge
              style={{
                backgroundColor: jobTypeBgColor(data.type),
                color: "#000",
              }}
              isBold
            >
              {data.type}
            </Lozenge>
          ) : data.type === "Configuration" ? (
            <Lozenge
              style={{
                backgroundColor: jobTypeBgColor(data.type),
                color: "#000",
              }}
              isBold
            >
              {data.type}
            </Lozenge>
          ) : String(data.type).toLowerCase() === "quick" ? (
            <Lozenge
              style={{
                backgroundColor: jobTypeBgColor(data.type),
                color: "#000",
              }}
              isBold
            >
              {data.type}
            </Lozenge>
          ) : (
            "-"
          ),
      },
      {
        key: createKey(data.startTime),
        content:
          data.startTime !== "-" ? (
            formatDateJobLog(data.startTime, false)
          ) : (
            <span className={styles.timeDisplay}>-</span>
          ),
      },
      {
        key: createKey(data.endTime),
        content:
          data.endTime !== "-" ? (
            formatDateJobLog(data.endTime, false)
          ) : (
            <span className={styles.timeDisplay}>-</span>
          ),
      },
      {
        key: createKey(data.timeTaken),

        content:
          data.status === "Queued" || data.status === "Running" ? (
            <span>
              ETA : ~
              {appType === "Backup"
                ? // ba ckup eta

                  secondsToDhms(
                    data.type === "Issues"
                      ? (totalIssueCount > 1400 ? totalIssueCount : 400) * 0.3
                      : 720
                  )
                : // restore eta
                  secondsToDhms(data.type === "Quick" ? 1800 : 1800)}
            </span>
          ) : (
            // successful jobs
            <span>{secondsToDhms(data.timeTakenSec)}</span>
          ),
      },
      {
        key: createKey(data.status),
        content: (
          <Tooltip content={data.status} position="top">
            <Lozenge
              style={{
                backgroundColor: statusBackColor(data.status),
                color: "#000",
              }}
              isBold
            >
              {data.status}
            </Lozenge>
          </Tooltip>
        ),
      },
      {
        key: createKey(data.userName),
        // content: data.initiatorAccountId,
        content:
          data.userName === "Not found" ? (
            data.initiatorAccountId
          ) : (
            <NameWrapper>
              <AvatarWrapper>
                <Avatar src={data.avatar} name={"Username"} size="small" />
              </AvatarWrapper>
              {data.userName === "-" ? (
                <Skeleton
                  width={"150px"}
                  count={1}
                  baseColor="lightgrey"
                  height={"10px"}
                />
              ) : (
                data.userName
              )}
            </NameWrapper>
          ),
      }, // {
      //   key: createKey(data.startedBy),
      //   content: data.startedBy,
      // },
      // {
      //   key: createKey(data.progress),
      //   content: data.progress,
      // },
      // {
      //   key: createKey(data.tag),
      //   content: data.tag,
      // },
      // {
      //   key: createKey(data.errorCodeDetails),
      //   content: data.errorCodeDetails,
      // },
    ],
  }));
